interface VariantStyles {
  variantClasses: string
  numberClasses: string
  finalClassName: string
}

export const getVariantClasses = (
  variant: 'red' | 'gray' | string | undefined,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  styles: any,
  className?: string,
): VariantStyles => {
  let variantClasses = ''
  let numberClasses = ''

  if (variant === 'red') {
    variantClasses = 'bg-[#ED1951] text-white'
    numberClasses = styles.numberRed
  } else if (variant === 'gray') {
    variantClasses = 'bg-[#3B4653] text-white'
    numberClasses = styles.numberGray
  } else {
    variantClasses = 'bg-transparent text-gray-800'
    numberClasses = ''
  }

  const mergedClassName = `${variantClasses} ${className || ''}`.trim()

  return {
    variantClasses: variantClasses,
    numberClasses: numberClasses,
    finalClassName: mergedClassName,
  }
}
